import React, { Fragment } from 'react';
// nodejs library that concatenates classes
//import classNames from 'classnames';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
// @material-ui/icons
import Assignment from '@material-ui/icons/Assignment';
// core components
import GridContainer from '../../components/UI/Grid/GridContainer';
import GridItem from '../../components/UI/Grid/GridItem';
import Button from '../../components/UI/CustomButtons/Button';

import totalStyle from '../../assets/jss/coscef/views/totalStyle';

const useStyles = makeStyles(totalStyle);

const Total = (props) => {
  const classes = useStyles();

  return (
    <Fragment>
      <GridContainer className={classes.titleRow}>
        <GridItem md={4} className={classes.mlAuto}>
          <Button color='white' className={classes.floatRight}>
            <Assignment /> {props.countArticulos} {props.nombreComponente}
          </Button>
        </GridItem>
      </GridContainer>
    </Fragment>
  );
};

export default Total;
